import apiClient from "./apiClient";

export interface StorageUsage {
  tier: "FREE" | "PLUS" | "PREMIUM";
  used: number;
  limit: number;
  remaining: number;
  usedLabel: string;
  limitLabel: string;
}

/** What is used, and what the tier actually allows — both from the server. */
export const getStorageUsage = async (): Promise<StorageUsage> => {
  const response = await apiClient.get("/documents/usage");
  return response.data.data;
};
